import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule, ConfigModule, CmsConfig, AuthGuard } from '@spartacus/core';
import { CardModule, MediaModule, IconModule, SpinnerModule } from '@spartacus/storefront';
import { UigSavedCartDetailsActionComponent } from './uig-saved-cart-details-action/uig-saved-cart-details-action.component';
import { UigSavedCartDetailsOverviewComponent } from './uig-saved-cart-details-overview/uig-saved-cart-details-overview.component';
import { UigSavedCartDetailsItemsComponent } from './uig-saved-cart-details-items/uig-saved-cart-details-items.component';
import { UigCartSharedModule } from '../../uig-cart-shared/uig-cart-shared.module';
import {CartSharedModule} from '@spartacus/cart/base/components';
import {AddToCartModule} from '@spartacus/cart/base/components/add-to-cart';

@NgModule({
    imports: [
      CartSharedModule,
      CommonModule,
      I18nModule,
      UrlModule,
      RouterModule,
      CardModule,
      MediaModule,
      AddToCartModule,
      IconModule,
      SpinnerModule,
      FormsModule,
      UigCartSharedModule,
      ConfigModule.withConfig({
        cmsComponents: {
          SavedCartDetailsOverviewComponent: {
            component: UigSavedCartDetailsOverviewComponent,
            guards: [AuthGuard],
          },
          SavedCartDetailsActionComponent: {
            component: UigSavedCartDetailsActionComponent,
            guards: [AuthGuard],
          },
          SavedCartDetailsItemsComponent: {
            component: UigSavedCartDetailsItemsComponent,
            guards: [AuthGuard],
          },
        },
      } as CmsConfig),
    ],
    declarations: [
        UigSavedCartDetailsOverviewComponent,
        UigSavedCartDetailsActionComponent,
        UigSavedCartDetailsItemsComponent
    ],
    exports: [
      UigSavedCartDetailsOverviewComponent,
      UigSavedCartDetailsActionComponent,
      UigSavedCartDetailsItemsComponent
    ],
  })
  export class UigSavedCartDetailsModule {}
